import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'
import { CommentData } from './types'

// API call function
const postComment = async (commentData: CommentData): Promise<CommentData> => {
  const url = `${baseUrl}/aws/comments/comments_table`
  console.log('[usePostTask] Submitting Comment Data:', commentData)

  const response = await axios.post(url, commentData)
  return response.data // Return the created task object
}

// Mutation hook
// Note: Optimistic updates are handled by useHandlePostComment which wraps this mutation.
// This hook just handles the API call and shows snackbars.
export const usePostComment = () => {
  const { showSnackbar } = useSnackbarContext()

  return useMutation<CommentData, Error, CommentData>({
    mutationFn: postComment,

    onError: error => {
      console.error('[usePostComment] Mutation Error:', error)
      showSnackbar((error as any).response?.data?.message || error.message, 'error')
    },

    onSuccess: data => {
      console.log('[usePostComment] Comment Created Successfully:', data)
      showSnackbar('Comment created successfully', 'success')
    },
  })
}
